<template>
    <AppHead
        :yoast-head="yoastHead"
        :watson-seo-head="watsonSeoHead"
    />

    <div class="content">
        <WatsonOrganismContent
            :content="content"
        />
    </div>
</template>

<script setup>
import AppHead from '../../layouts/components/AppHead.vue';

defineProps({
    yoastHead: {
        type: String,
        required: false,
        default: '',
    },
    watsonSeoHead: {
        type: String,
        required: false,
        default: '',
    },
    content: {
        type: Object,
        required: true,
    },
});
</script>

<script>
import CleanLayout from '../../../../js/Layouts/Clean-index.vue';

export default {
    layout: CleanLayout,
};
</script>
